export const shouldShowUsagePercentage = (usagePercentage?: number | null) =>
    usagePercentage && true && usagePercentage > 90 && usagePercentage < 100;
